import {pascalCaseToKebab} from "../base.js"
import router from "./router/index.js";

import App from './App.vue'
import { createApp } from 'vue'

/* global window */

let appData = Object.assign({}, window[App.name+'Data']);
const app = createApp(App, appData);
app.use(router);
app.mount('#'+pascalCaseToKebab(App.name))